const initialState = {
  dadosSolicitante: null,
  dadosMedicamento: null,
  dadosTecnologiaSaude: null,
  dadosJustificativa: null,
  dadosDocumentos: null
};

const analiseLaboratorialReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'dadosSolicitante':
      return {
        ...state,
        dadosSolicitante: action.payload.dadosSolicitante
      };
    
    case 'dadosMedicamento':
      return {
        ...state,
        dadosMedicamento: action.payload.dadosMedicamento
      };
    
    case 'dadosTecnologiaSaude':
      return {
        ...state,
        dadosTecnologiaSaude: action.payload.dadosTecnologiaSaude
      };
    
    case 'dadosJustificativa':
      return {
        ...state,
        dadosJustificativa: action.payload.dadosJustificativa
      };
    
    case 'dadosDocumentos':
      return {
        ...state,
        dadosDocumentos: action.payload.dadosDocumentos
      };
    
    case 'CLEAR_FORM':
      return initialState;
    
    default:
      return state;
  }
};

export default analiseLaboratorialReducer;
